import React from 'react'
import { SelectProductType } from './SelectProductType'
import CreateQuoteClan from './CreateQuoteClan/Createquote'
import CreateQuoteMonamodi from './CreateQuoteMonamodi/Createquote'
import CreateQuoteMotshelo from './CreateQuoteMotshelo/Createquote'

export const CreateQuoteSwitch = (props) => {
  const [productType, setProductType] = React.useState('')

  const ProductTypes = {
    Monamodi: 'Monamodi Funeral Plan',
    FamilyClan: 'Family Clan Cover',
    Motshelo: 'Motshelo Group Cover'
  };

  if (!productType) {
    return <SelectProductType setProductType={setProductType} productType={productType} />
  } else {
    switch (productType) {
      case ProductTypes.Monamodi:
        return <CreateQuoteMonamodi {...props} productType={productType}  setProductType={setProductType} createQuoteError={props.createQuoteError}  />

      case ProductTypes.FamilyClan:
        return <CreateQuoteClan {...props} productType={productType} setProductType={setProductType} createQuoteError={props.createQuoteError}  />

      case ProductTypes.Motshelo:
        return <CreateQuoteMotshelo {...props} productType={productType} setProductType={setProductType} createQuoteError={props.createQuoteError}  />

      default:
        return <SelectProductType setProductType={setProductType} productType={productType} />
    }
  }
}
